import React from 'react';
var VeltCommentDialogOptionsDropdownContentNotificationUnsubscribeWireframe = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-options-dropdown-content-notification-unsubscribe-wireframe", null, children));
};
export default VeltCommentDialogOptionsDropdownContentNotificationUnsubscribeWireframe;
